import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/PreadviseProxy.css';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import UploadFile from '../../Shared/UploadFile';
import Loader from "react-loader";
import SuccessModal from '../../Shared/SuccessModal';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import DropDownTable from '../../Shared/DropDownTable';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { PREADVISE_PROXY } from '../../../Services/config/apiEndPoints';
import AddProfileModal from '../../Shared/GenericModalError';
class PreadviseProxy extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            shippingLine: '',
            ProxyDocumentdropdown: false,
            shippingLineData: [],
            errors: {},
            loaderTime: false,
            PageDisable: false,
            FilePathPreadvise: '',
            hasOpen: false,
            hasOpenPending: false,
            errorMessage: ''
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    shippingLineData = [{ name: "MSc" }, { name: "ONE" }]
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    OnValidated = () => {
        this.setState({ hasOpen: true });
    }
    onClosePending = () => {
        this.setState({ hasOpenPending: false });
    };
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ ProxyDocumentdropdown: false });
        }
    };
    uploadFileFunction = (uploadConfirm) => {
        let errors = { ...this.state.errors };
        errors["fileupload"] = '';
        this.setState({ errors: errors });
        document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
    }
    removeProxyLink = () => {
        let path = "";
        this.setState({ FilePathPreadvise: path });
    }
    setLoaderCIPC = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkCIPC = (filePathURL) => {
        // for loader end
        this.setState({ FilePathPreadvise: filePathURL });
        this.setState({ loaderTime: false });
        this.setState({ PageDisable: false });
    }
    addProxyPOST = () => {
        ApiCall(
            'POST',
            utilityBaseURL + PREADVISE_PROXY,
            {
                "shippingLine": this.state.shippingLine,
                "approvalStatus": "",
                "statusDate": "",
                "documentPath": this.state.FilePathPreadvise
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                    this.setState({ errorMessage: data.data.message, hasOpenPending: true });
                } else {
                    console.log('I am 200!');
                    this.OnValidated();
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    handleSubmit = () => {
        if (this.handleValidation()) {
            this.addProxyPOST();
        }
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (this.state.FilePathPreadvise?.length === 0) {
            formIsValid = false;
            errors["fileupload"] = Message.validation.required;
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
        }
        if (this.state.shippingLine === '') {
            formIsValid = false;
            errors["caad066"] = Message.validation.required;
            document.getElementById('caad066').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('caad066').style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    toggleDropdownProxyDocument = () => {
        this.setState({ ProxyDocumentdropdown: !this.state.ProxyDocumentdropdown });
    };
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/home', {})
    };
    changeRoleTypeProxyDocument = (event) => {
        const found = this.shippingLineData?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({
            shippingLine: found.name,
            ProxyDocumentdropdown: !this.state.ProxyDocumentdropdown,
        });
        let errors = { ...this.state.errors };
        errors["caad066"] = '';
        this.setState({ errors: errors });
        document.getElementById('caad066').style.borderColor = ColorCode.colorCode.black;
    }
    render() {
        let ProxyDocumentdropdownImage = this.state.ProxyDocumentdropdown ? <img src={uparrow} /> : <img src={downarrow} />
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.preAdviseProxyPageTitle} description={TitleDescription.preAdviseProxyPageDescription} />
                <Loader
                    loaded={!this.state.loaderTime}
                    lines={10}
                    length={10}
                    width={8}
                    radius={10}
                    corners={1}
                    rotate={0}
                    direction={1}
                    color="#000"
                    speed={1}
                    trail={60}
                    shadow={false}
                    hwaccel={false}
                    className="spinner"
                    zIndex={2e9}
                    top="50%"
                    left="50%"
                    scale={1.0}
                    loadedClassName="loadedContent"
                />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullpreproProxy">
                    <div id="caacsnobox1preproProxy">
                        <nav class="caacnononavbar">
                            <div className="arcaacnonavbarnamePreProxy">
                                <small id="nonavc">Pre-advise Proxy</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="arcaanotificationmaincardpreproProxy">
                            <div class="caaoncsdivlow1preex">
                                <div class="csdivlow2">
                                    Upload Pre-advise Proxy Document
                                </div>
                            </div>
                            <div class="preprodiv">
                                <div class="preprodivinPreProxy">
                                    <div class="caadivup55PreProxy">
                                        <div class="caadivup3PreProxy">
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    readOnly class="input" placeholder="Select Proxy Document Type"
                                                    type="text" id="caad066"
                                                    name="caad066"
                                                    value={this.state.shippingLine}
                                                />
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownProxyDocument}>{ProxyDocumentdropdownImage}</i>
                                                <div className="error1">{this.state.errors["caad066"]}</div>
                                            </div>
                                            {this.state.ProxyDocumentdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.shippingLineData?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeProxyDocument(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3PreProxy">
                                            <div className="pass-wrapper" id="caad07" >
                                                <UploadFile uploaddivid="uploadCIPC" idupload="upload"
                                                    name="fileupload"
                                                    fileType="jpeg, jpg, png, pdf"
                                                    setUploadConfirm={this.uploadFileFunction}
                                                    removeLink={this.removeProxyLink}
                                                    upload_link="cipcUpload" uploadicon="cipcIcon"
                                                    setFileLink={this.setUploadLinkCIPC}
                                                    setLoader={this.setLoaderCIPC}
                                                    staticFileName={'Proxy_document.'}
                                                />
                                                <div className="error1">{this.state.errors["fileupload"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caabuttdivarzproProxy">
                                <Button class="caabuttdiv1PreProxy" onClick={this.handleSubmit}>
                                    <small class="caabuttdiv2">Submit</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <SuccessModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="successtext1createpreadvise">You have successfully submitted </small>
                            <small class="successtext1createpreadvise"> proxy for approval.</small>
                        </div>
                    </div>
                </SuccessModal>
                {this.state.hasOpenPending ? <AddProfileModal hasOpen={this.state.hasOpenPending} onCloseModal={this.onClosePending} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="addprofilemodalsmall">{this.state.errorMessage}</small>
                        </div>
                    </div>
                </AddProfileModal> : null}
                <div class="caanotifooter01ahzpreexp">
                    <Footer />
                </div>
                <div class="caanotifooter02ahzpreexp">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default PreadviseProxy;